(() => {
  const rangeSelector = '#tesery-full-front-ppf .tp-ba-range';

  const updateComparison = (range) => {
    const slider = range.closest('.tp-ba-slider');
    if (!slider) return;

    const position = Math.min(100, Math.max(0, Number(range.value) || 0));
    slider.style.setProperty('--position', `${position}%`);
  };

  const initializeComparisons = (root = document) => {
    root.querySelectorAll(rangeSelector).forEach(updateComparison);
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches(rangeSelector)) updateComparison(event.target);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches(rangeSelector)) updateComparison(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeComparisons());
  } else {
    initializeComparisons();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeComparisons(event.target);
  });
})();
